// extracted by mini-css-extract-plugin
module.exports = {"job_title":"personalProjects_job_title__28xMY","coursework":"personalProjects_coursework__2y0IO"};